import PagePhase from '@/enum/PagePhase'

export default {
    gameClientType: null, // GameClientType.Offline,
    gameType: null,

    currentTheme: null,
    currentCase: null,
    currentStoryId: null,
    startStoryId: null,

    lastEmojiCode: null,

    currentGamePhase: null,

    currentPageIndex: -1,
    currentPagePhase: PagePhase.Normal,
    pageHistory: [],

    gameClientCloseRedirectUrl: '/',
    gameClientTryReconnect: false,

    errorMessage: null,
    errorIcon: null,
    navigationGuardEnabled: false,

    //license: null,
    license: '333333',

    isReady: false,
}
